/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Session_Success_ContentInputs */

const en_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You got some new plants in your forest 🌲`)
};

const ar_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد حصلت على بعض النباتات الجديدة في غابتك 🌲`)
};

const de_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast ein paar neue Pflanzen in deinem Wald 🌲`)
};

const es_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes algunas plantas nuevas en tu bosque 🌲`)
};

const fr_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez de nouvelles plantes dans votre forêt 🌲`)
};

const it_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai delle nuove piante nella tua foresta 🌲`)
};

const ja_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森に新しい植物が増えました🌲`)
};

const ko_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숲에 새로운 식물이 도착했어요 🌲`)
};

const pt_br_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você tem novas plantas na sua floresta🌲`)
};

const ru_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В вашем лесу появились новые растения 🌲`)
};

const th_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณได้รับต้นไม้ใหม่ ๆ ในป่าของคุณแล้ว 🌲`)
};

const tr_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ormanında yeni bitkiler var🌲`)
};

const zh_cn_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的森林里又多了新植物 🌲`)
};

const zh_tw_notification_session_success_content = /** @type {(inputs: Notification_Session_Success_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的森林裡又多了新植物 🌲`)
};

/**
* | output |
* | --- |
* | "You got some new plants in your forest 🌲" |
*
* @param {Notification_Session_Success_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const notification_session_success_content = /** @type {((inputs?: Notification_Session_Success_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Session_Success_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notification_session_success_content(inputs)
	if (locale === "ar") return ar_notification_session_success_content(inputs)
	if (locale === "de") return de_notification_session_success_content(inputs)
	if (locale === "es") return es_notification_session_success_content(inputs)
	if (locale === "fr") return fr_notification_session_success_content(inputs)
	if (locale === "it") return it_notification_session_success_content(inputs)
	if (locale === "ja") return ja_notification_session_success_content(inputs)
	if (locale === "ko") return ko_notification_session_success_content(inputs)
	if (locale === "pt_br") return pt_br_notification_session_success_content(inputs)
	if (locale === "ru") return ru_notification_session_success_content(inputs)
	if (locale === "th") return th_notification_session_success_content(inputs)
	if (locale === "tr") return tr_notification_session_success_content(inputs)
	if (locale === "zh_cn") return zh_cn_notification_session_success_content(inputs)
	return zh_tw_notification_session_success_content(inputs)
});